import {
  ADOBE_EDIT_SAVED_ITEM_EVENT_KEY,
  ADOBE_EDIT_SAVED_ITEM_AFS_EVENT_KEY
} from "../../../../../../services/analytics/constants";
import getFulfilmentType, {
  FULFILMENT_TYPE
} from "../../../../../../getFulfilmentType";

const getEvents = ({ sourceId, sellerId }) => {
  const events = [ADOBE_EDIT_SAVED_ITEM_EVENT_KEY];

  const fulfilmentType = getFulfilmentType({ sourceId, sellerId });

  if (fulfilmentType === FULFILMENT_TYPE.AFS) {
    events.push(ADOBE_EDIT_SAVED_ITEM_AFS_EVENT_KEY);
  }

  return events;
};

export default getEvents;
